<script>
import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";
import Input from "@/pages/components/form/input-only/input.vue";

export default {
  components: { MultipleRadios, Input },
  props: {
    modelValue: {
      required: true,
    },
    name: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    groupClasses: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
    testValue: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      inputValue: this.modelValue,
    };
  },
  computed: {
    isWithinMargin() {
      if (this.inputValue === null) return false;
      const inputValue = parseFloat(this.inputValue) * 1000;
      let margin;
      if (this.testValue === 0) {
        margin = 25000;
      } else {
        margin = this.testValue * 0.25;
      }
      return Math.abs(this.testValue - inputValue) <= margin;
    },
    computedValue() {
      return this.isWithinMargin ? 'OK' : 'Fout';
    }
  },
  methods: {
    handleInput(value) {
      this.inputValue = value;
      this.$emit('update:modelValue', value);
    },
  },
}
</script>

<template>
  <div class="form-group row" :class="{ [groupClasses]: typeof groupClasses != 'undefined' }">
    <div class="col-4">
      <label class="form-label">{{ label }}</label>
    </div>

    <div class="col-4">
      <Input
          v-bind="$attrs"
          :name="name"
          :model-value="inputValue"
          :required="required"
          @update:modelValue="handleInput"
      />
    </div>

    <div class="col-4">
      <MultipleRadios
          v-bind="$attrs"
          :name="name"
          :model-value="computedValue"
          :required="required"
          :options="[
          { label: 'OK', value: 'OK' },
          { label: 'Fout', value: 'Fout' },
        ]"
          disabled="disabled"
      />
    </div>
  </div>
</template>
